/** European roulette pocket order — matches BetBond mobile `CasinoScreen/pockets.js`. */
export const ROULETTE_POCKETS = [
  { number: 0, color: "green" },
  { number: 32, color: "red" },
  { number: 15, color: "black" },
  { number: 19, color: "red" },
  { number: 4, color: "black" },
  { number: 21, color: "red" },
  { number: 2, color: "black" },
  { number: 25, color: "red" },
  { number: 17, color: "black" },
  { number: 34, color: "red" },
  { number: 6, color: "black" },
  { number: 27, color: "red" },
  { number: 13, color: "black" },
  { number: 36, color: "red" },
  { number: 11, color: "black" },
  { number: 30, color: "red" },
  { number: 8, color: "black" },
  { number: 23, color: "red" },
  { number: 10, color: "black" },
  { number: 5, color: "red" },
  { number: 24, color: "black" },
  { number: 16, color: "red" },
  { number: 33, color: "black" },
  { number: 1, color: "red" },
  { number: 20, color: "black" },
  { number: 14, color: "red" },
  { number: 31, color: "black" },
  { number: 9, color: "red" },
  { number: 22, color: "black" },
  { number: 18, color: "red" },
  { number: 29, color: "black" },
  { number: 7, color: "red" },
  { number: 28, color: "black" },
  { number: 12, color: "red" },
  { number: 35, color: "black" },
  { number: 3, color: "red" },
  { number: 26, color: "black" },
];

export const POCKET_FILL = {
  red: "#C62828",
  black: "#141414",
  green: "#2E7D32",
};

export function getPocketIndexForNumber(number) {
  return ROULETTE_POCKETS.findIndex((p) => p.number === number);
}

/** Wheel rotation (deg) so pocket index lands under the top pointer, plus extra full spins. */
export function getRouletteRotationForPocketIndex(pocketIndex, extraFullSpins = 7) {
  const count = ROULETTE_POCKETS.length;
  const degPerPocket = 360 / count;
  const midAngle = (pocketIndex + 0.5) * degPerPocket;
  return 270 - midAngle + extraFullSpins * 360;
}
